module.exports = __webpack_public_path__ + "static/hero-33745039b47911e4230b332a696fea7a.jpg";